import localforage from 'localforage'
import { observer } from 'mobx-react-lite'

import Button from './Button'
import { useLocalStorage } from '../util'

import type { StoreModel } from '../store'

function Td({ children }: { children: React.ReactNode }) {
  return <td className="max-w-[500px] p-0.5 pl-1 pr-1">{children}</td>
}

const ChannelList = observer(function ({ model }: { model: StoreModel }) {
  const [showTable, setShowTable] = useLocalStorage('show_playlists', true)
  const { processing } = model
  return (
    <div>
      <Button
        onClick={() => {
          setShowTable(s => !s)
        }}
      >
        {showTable ? 'Hide channel table' : 'Show channel table'}
      </Button>
      {processing ? (
        <div>
          Currently processing: {processing.name} ({processing.current}/
          {processing.total})
        </div>
      ) : null}
      {showTable ? (
        <div className="overflow-x-auto max-h-[200px] p-4">
          <table className="table table-pin-rows table-zebra">
            <thead>
              <tr>
                <th>Channels loaded</th>
                <th>Filter</th>
                <th>Refresh</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <Td>
                  All ({Object.values(model.counts).reduce((a, b) => a + b, 0)})
                </Td>
                <Td>
                  <Button
                    className="btn-xs"
                    onClick={() => {
                      model.setFilter('')
                    }}
                  >
                    Show all
                  </Button>
                </Td>
                <Td>
                  <Button
                    className="btn-xs"
                    onClick={() => {
                      // eslint-disable-next-line @typescript-eslint/no-floating-promises
                      ;(async () => {
                        await Promise.all(
                          Object.values(model.channelToId).map(item =>
                            localforage.removeItem(item),
                          ),
                        )
                        globalThis.location.reload()
                      })()
                    }}
                  >
                    Clear all and refresh
                  </Button>
                </Td>
              </tr>
              {Object.entries(model.counts).map(([key, value]) => (
                <tr key={key}>
                  <Td>
                    {key} ({value || 0})
                  </Td>
                  <Td>
                    <Button
                      className="btn-xs"
                      onClick={() => {
                        model.setFilter(key)
                      }}
                    >
                      Filter
                    </Button>
                  </Td>
                  <Td>
                    <Button
                      className="btn-xs"
                      onClick={() => {
                        // eslint-disable-next-line @typescript-eslint/no-floating-promises
                        ;(async () => {
                          await localforage.removeItem(model.channelToId[key])
                          globalThis.location.reload()
                        })()
                      }}
                    >
                      Clear data and refresh
                    </Button>
                  </Td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : null}
    </div>
  )
})

export default ChannelList
